import React from 'react';
import { FormattedMessage } from '../../util/reactIntl';
import { findOptionsForSelectFilter } from '../../util/search';

import moment from 'moment';
import classNames from 'classnames';

import { disciplinesConfig, rolesConfig } from '../../marketplace-custom-config';
import css from './ProfilePage.module.css';

const findConfigOptionLabels = (configKey, filterConfig, selectedKeys) => {
  const hasSelectedKeys = selectedKeys?.length > 0;
  if (!hasSelectedKeys) {
    return null;
  }

  const options = findOptionsForSelectFilter(configKey, filterConfig);
  const selectedOptions = options.filter(o => selectedKeys.includes(o.key));
  const selectedOptionLabels = selectedOptions.map(o => o.label);
  const joinedOptionLabels = selectedOptionLabels.join(', ');

  return joinedOptionLabels;
};

const detailItem = (detailName, detailValue) => (
  <div className={css.detailItem}>
    <span className={css.detailName}>{detailName}</span>
    <span className={css.detailValue}>{detailValue}</span>
  </div>
);

const SectionDetails = props => {
  const { intl, profileUser, filterConfig, isBetaMode } = props;

  const { publicData } = profileUser.attributes.profile;
  const { bio } = profileUser.attributes.profile;

  const profileUserCreatedDate = moment(profileUser.attributes.createdAt).format('MMMM YYYY');
  const profileUserLanguages =
    findConfigOptionLabels('language', filterConfig, publicData?.languages) || 'N/A';
  const profileUserLocationAddress = publicData?.location?.location?.address || 'N/A';
  // Community profile prompt writes bio to publicData.bio; legacy users have
  // it on profile.bio. Prefer the public-data one in beta.
  const profileBio = publicData?.bio || bio || 'N/A';
  const disciplineKey = publicData?.discipline;
  const disciplineLabel = disciplineKey
    ? disciplinesConfig.find(d => d.value === disciplineKey)?.label || disciplineKey
    : 'N/A';
  const roleKeys = Array.isArray(publicData?.role) ? publicData.role : [];
  const roleLabel = roleKeys.length
    ? roleKeys
        .map(k => rolesConfig.find(r => r.value === k)?.label || k)
        .join(', ')
    : 'N/A';

  return (
    <div className={classNames(css.sectionContent, css.sectionDetails)}>
      <h2 className={css.sectionTitle}>
        <FormattedMessage id="ProfilePage.detailsTitle" />
      </h2>
      <div className={css.detailItems}>
        {!isBetaMode && detailItem(
          intl.formatMessage({ id: 'ProfilePage.detailsLocation' }),
          profileUserLocationAddress
        )}
        {!isBetaMode && detailItem(
          intl.formatMessage({ id: 'ProfilePage.detailsLanguages' }),
          profileUserLanguages
        )}
        {isBetaMode && detailItem(
          intl.formatMessage({ id: 'ProfilePage.detailsDiscipline' }),
          disciplineLabel
        )}
        {isBetaMode && detailItem(
          intl.formatMessage({ id: 'ProfilePage.detailsRole' }),
          roleLabel
        )}
        {detailItem(
          intl.formatMessage({ id: 'ProfilePage.detailsCreatedDate' }),
          profileUserCreatedDate
        )}
        {detailItem(
          intl.formatMessage({ id: 'ProfilePage.detailsBio' }),
          profileBio
        )}
      </div>
    </div>
  );
};

export default SectionDetails;
